module.exports = __webpack_public_path__ + "media/landing.9c11e5c8.mp4";